import Component from "./BookingDetails";

export default Component;
